import { render } from "./crate-report.vue?vue&type=template&id=0a5e7182"
import script from "./crate-report.vue?vue&type=script&lang=js"
export * from "./crate-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__